import * as React from 'react';
import { inject } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

// Polyfill ie11
// import 'core-js/es/array';

import Form from './components/Form';

import Image, { ImageType } from '../../components/image/image';

import '../../components/bubble/bubble.scss';
import Container from '../../components/layout/container';
import Bubble, { BubbleType } from '../../components/bubble/bubble';

@inject('routing', 'dataStore')
class Login extends React.Component<RouteComponentProps<any> & any> {
  public componentDidMount() {
    const {
      dataStore: { reset }
    } = this.props;
    reset();
  }

  public render() {
    return (
      <Container>
        <Bubble type={BubbleType.Right}>
          <Form />
        </Bubble>
        <Image
          type={ImageType.startKleermaker}
          imgSrc="/images/svg/start-kleermaker.svg"
          alt={'Sporti'}
        />
        <Image
          type={ImageType.startRocket}
          imgSrc="/images/svg/start-flag-rocket.svg"
          alt={'Rocket'}
        />
      </Container>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/containers/login/Login.tsx